<template lang="pug">

  .lesson-block.main-block
    .lesson-block__content(v-if="!isEditLocal")
      img.lesson-block__image(:src="content.img.url")


    template(v-else)
      .lesson-block__content
        .lesson-block__pict(:style="{backgroundImage: `url('`+contentLocal.img.url+`')`}")
        //- Input.lesson-block__edit(
        //- 		v-model="contentLocal.photoUrl"
        //- 		title="Заголовок")

        File(
          v-if="contentLocal.img.id"
          :file="contentLocal.img"
          icon="image"
          :canDelete="false"
        )

        UploadFile(
          @getFiles="getFile"
          :fileMime="['image/*']"
          :fileExt="[]"
        )

        .lesson-block__buttons
          Button.-xs-(@click="saveBlock" :isLoading="isLoading") Сохранить
          ButtonCancel.-xs-.hover__link(@click="cancel") Отмена


    ControlsArrow.lesson__controls(
      :firstBlock="isFirstBlock"
      :lastBlock="isLastBlock"
      v-if="$permissionsUpdate"
      @moveUp="moveUp"
      @moveDown="moveDown"
    )

    OptionsList.course-lesson__options(
      v-if="optionsFields.length"
      :optionsFields="optionsFields"
    )

</template>

<script>
import _ from 'lodash';
import File from '@/components/File/File';
import UploadFile from '@/components/Form/UploadFiles';
import blockPermissionMixin from '@/views/Courses/Lesson/components/block.permission.mixin';

export default {
  components: {
    File,
    UploadFile
  },
  mixins: [blockPermissionMixin],
  props: {
    permissions: {},
    isEdit: {
      default: false,
      type: Boolean
    },
    content: {},
    arrows: {
      default: true,
      type: Boolean
    },
    isFirstBlock: {
      default: false,
      type: Boolean
    },
    isLastBlock: {
      default: false,
      type: Boolean
    },
    isLoading: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      contentLocal: {},
      isEditLocal: false
    };
  },
  computed: {
    optionsFields() {
      const arr = [];
      if (this.$permissionsUpdate) {
        arr.push({
          text: 'Редактировать',
          func: this.openBlockEdit,
          icon: 'edit'
        });
      }

      if (this.$permissionsCreate) {
        arr.push({
          text: 'Дублировать',
          func: this.duplicateBlock,
          icon: 'copy'
        });
      }

      if (this.$permissionsDelete) {
        arr.push({
          text: 'Удалить',
          func: this.deleteBlock,
          icon: 'delete',
          iconWidth: '10px',
          confirm: true,
          confirmTitle: 'Вы уверены, что хотите удалить этот блок?',
          confirmDescription: 'Блок будет удален навсегда',
          confirmApplyText: 'Удалить',
          confirmCancelText: 'Отменить',
          red: true
        });
      }

      return arr;
    }
  },
  watch: {
    isEditDefault() {
      this.isEditLocal = this.isEdit;
    },
    content() {
      this.setData();
    }
  },
  mounted() {
    this.setData();

    if (this.contentLocal.forceEdit) {
      this.isEditLocal = true;
      delete this.contentLocal.forceEdit;
    }
  },
  methods: {
    setData() {
      this.contentLocal = _.cloneDeep(this.content);
    },
    openBlockEdit() {
      this.isEditLocal = true;
    },
    deleteBlock() {
      this.$emit('deleteBlock');
    },
    saveBlock() {
      setTimeout(() => {
        this.isEditLocal = false;
      }, 1000);

      this.$emit('saveBlock', this.contentLocal);
    },
    cancel() {
      this.isEditLocal = false;
      this.setData();
    },
    duplicateBlock() {
      this.$emit('duplicateBlock');
    },
    moveUp() {
      this.$emit('moveUp');
    },
    moveDown() {
      this.$emit('moveDown');
    },
    async getFile({ formData }) {
      const res = await this.$store.dispatch('ajax/uploadImage', { formData });
      if (res) {
        this.contentLocal.img = { ...res };
      }
    }
  }
};
</script>
